module.exports = __webpack_public_path__ + "img/lettersending.db40a617.gif";